import React from "react"
// import { Storage } from "aws-amplify"
import jwt from "jsonwebtoken"
// import { v4 as uuid } from "uuid"
// import SendIcon from "@material-ui/icons/Send"

import ViewEmail from "../../components/ViewEmail"
import ViewSharedDocuments from "../../components/ViewSharedDocuments"
// import Button from "../../components/Button"

const baseUrl = "https://app.condoaxis.com"

const DocumentsSendPreview = ({ sendData }) => {
  // const [preview, setPreview] = React.useState("")
  const token = jwt.sign(
    {
      data: sendData,
    },
    "beacdf97-819e-4dac-9b31-e5425b19413d",
    { expiresIn: "14d" }
  )
  // const tokenKey = `u/${uuid()}`
  const longUrl = `${baseUrl}/documents/${token}`
  // const shortUrl = `${baseUrl}/${tokenKey}`

  // async function urlShortener() {
  //   try {
  //     // Storage.configure({ AWSS3: {
  //     //   bucket: "staging.condoaxis.com",
  //     //   region: "us-east-1"
  //     // }})
  //     await Storage.put(`${tokenKey}`, "redirect", {
  //       // bucket: "staging.condoaxis.com",
  //       contentType: "text/plain",
  //       metadata: {
  //         WebsiteRedirectLocation: longUrl,
  //       },
  //     })
  //   } catch (error) {
  //     console.log("error: ", error)
  //   }
  // }
  // urlShortener()

  // const sendDocuments = () => {
  //   setMessage({
  //     content: "Documents successfully sent",
  //     open: true,
  //     type: "success",
  //   })
  //   setPreview(`/documents/${token}`)
  // }

  return (
    <>
      <ViewEmail sendData={sendData} token={token} url={longUrl} />
      <ViewSharedDocuments sendData={sendData} />
      {/* <Button
        onClick={sendDocuments}
        endIcon={<SendIcon />}
      >
        Send
      </Button> */}
      {/* <div>{preview}</div> */}
    </>
  )
}

export default DocumentsSendPreview
